"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const coreToolRegistry = {
  displayProjects: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./display-projects").then(({ DisplayProjectsToolView }) => ({
        default: DisplayProjectsToolView,
      }))
    ),
  },
  displayEmployee: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./display-employee").then(({ DisplayEmployeeToolView }) => ({
        default: DisplayEmployeeToolView,
      }))
    ),
  },
  displayDocuments: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./display-documents").then(({ DisplayDocumentsToolView }) => ({
        default: DisplayDocumentsToolView,
      }))
    ),
  },
  getEmployeePhotos: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./get-employee-photos").then(({ GetEmployeePhotosToolView }) => ({
        default: GetEmployeePhotosToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
